var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54318 16.1892L5.15938 8.86591M1.9004 10.3719L2.14463 15.0321C2.18317 15.7675 2.81055 16.3324 3.54592 16.2939L12.4845 15.8254C13.4703 15.7738 14.2709 15.0106 14.3698 14.0284L14.8425 9.33055C14.9652 8.11094 13.972 7.0689 12.7479 7.13305L10.4156 7.25528C10.0479 7.27455 9.73425 6.9921 9.71498 6.62441L9.59167 4.27154C9.54416 3.36488 8.77065 2.66842 7.864 2.71593C7.64775 2.72726 7.45845 2.86489 7.38098 3.06711L5.31438 8.46133C5.22013 8.70736 4.98983 8.87479 4.72673 8.88858L3.16212 8.97058C2.42675 9.00912 1.86186 9.6365 1.9004 10.3719Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_1367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.115234 1.78687) rotate(-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.77ee3b4dcf2d476048b58fc86f14eb0a.svg";
export { ForwardRef as ReactComponent };